import { useCallback } from 'react';

import { extractBankPlaceholders, slateToHtml, slateToText } from 'src/components/RichSlate';
import { captureMessage } from 'src/lib/sentry';

export const useHandlers = ({ onChange }) => {
  const handleChange = useCallback(
    (newValue) => {
      try {
        const text = slateToText(newValue);
        const html = slateToHtml(newValue);
        const { placeholders, updatedValue } = extractBankPlaceholders(newValue);
        const serializedUpdatedValue = slateToText(updatedValue);

        const instructionsData = {
          html,
          serialized: serializedUpdatedValue,
          placeholders,
          text: text,
        };
        onChange(text, instructionsData);
      } catch (error) {
        captureMessage('Prompt field issue', {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'InstructionsTextarea/useHandlers -> handleChange',
          },
        });
      }
    },
    [onChange]
  );

  return {
    handleChange,
  };
};
